SupportOrderSummaryView = require('./order_summary_view')

class SupportV2OrderSummaryView extends SupportOrderSummaryView

  buildOrderSummaryParams: ->
    orderSummaryParams = SupportOrderSummaryView::buildOrderSummaryParams.call(this)
    orderSummaryParams.isV2 = true
    orderSummaryParams

module.exports = SupportV2OrderSummaryView
